import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const firstCellPadding = css`
  padding-inline: var(--padding-first-cell-left) var(--padding-first-cell-right);
`;

export const lastCellPadding = css`
  padding-inline: var(--padding-last-cell-left) var(--padding-last-cell-right);
`;

export const SearchTableRow = styled(Horizontal)`
  --current-row-color: var(--c-black);
  display: grid;
  grid-template-columns: subgrid;
  grid-column: span var(--all-columns);
  grid-column-gap: 0;
  border-bottom: solid 1px var(--c-nd-150-opaque);
  align-items: stretch;
  background-color: var(--current-row-color);

  &:last-of-type {
    border-bottom: none;
  }
`;

export const CellGrow = styled.div`
  display: none;
  @media ${laptopAndAbove} {
    display: block;
  }
`;

const FirstUICell = styled(Horizontal)`
  position: sticky;
  background: var(--first-cell-background-color, var(--current-row-color));
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  ${firstCellPadding}
`;

const FirstUICellBlur = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  bottom: 0;
  background: linear-gradient(
    90deg,
    var(--current-row-color) 0%,
    rgba(16, 16, 16, 0) 100%
  );
  z-index: 1;
  width: var(--double-unit);
`;

export const SearchTableFirstCell = ({ children }: { children: ReactNode }) => (
  <FirstUICell gap={2}>
    {children}
    <FirstUICellBlur />
  </FirstUICell>
);

const LastUICell = styled(Vertical).attrs({ gap: 0.5 })`
  justify-content: center;
  align-items: flex-end;
  ${lastCellPadding}
  @media ${laptopAndAbove} {
    position: sticky;
    background-color: var(--current-row-color);
    right: 0;
    z-index: 1;
  }
`;

const LastUICellBlur = styled.div`
  position: absolute;
  top: 0;
  right: 100%;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(16, 16, 16, 0) 0%,
    var(--current-row-color) 100%
  );
  z-index: 1;
  width: var(--double-unit);
  display: none;
  @media ${laptopAndAbove} {
    display: block;
  }
`;

export const SearchTableLastCell = ({
  children,
  isLaptopOrAbove,
}: {
  children: ReactNode;
  isLaptopOrAbove?: boolean;
}) => (
  <LastUICell>
    {!!isLaptopOrAbove && <LastUICellBlur />}
    {children}
  </LastUICell>
);

export const Cell = styled(Horizontal)`
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 var(--unit);
  @media ${laptopAndAbove} {
    padding: 0 var(--intermediate-unit);
  }
`;
